export default __webpack_public_path__ + "static/media/cityam.59291812.svg";